import Sessionschildren from "./reviewer/Sessionschildren";
import ReviwerProfileChildren from "@/router/certipers/reviewer/ReviewerProfileChildren";

const ReviewerDashboard = () =>
  import(/* webpackChunkName: "Rest" */ "@/components/certipers-reviewer/ReviewerDashboard.vue");

const ReviewerSessions = () =>
  import(/* webpackChunkName: "Rest" */ "@/components/certipers-reviewer/ReviewerSessions.vue");

// TODO: update component to that of reviewer
const ReviewerProfile = () =>
  import(/* webpackChunkName: "Rest" */ "@/components/certipers-reviewer/ReviewerProfile.vue");

const CorrectionUserSession = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-reviewer/ReviewerCorrectionUserSession.vue"
  );

export default [
  {
    path: "",
    redirect: { name: "reviewer-dashboard" },
  },
  {
    path: "dashboard",
    name: "reviewer-dashboard",
    component: ReviewerDashboard,
  },
  {
    path: "sessions",
    children: Sessionschildren,
    component: ReviewerSessions,
  },
  {
    path: "profile",
    children: ReviwerProfileChildren,
    component: ReviewerProfile,
  },
  {
    path: "session/:userSessionUuid?/correction",
    name: "reviewer-correctionUserSession",
    component: CorrectionUserSession,
  },
];
